export default {
  fzjn: "Skill",
  fzda: "Profile",
  fzpc: "Review",
  djmb: "Best Build",
  ydl: "Views",
  dz: "Like",
  sc: "Bookmarks",
  pl: "Comments",
  fx: "Share",
  fhsy: "Home",
  xzjs: "Characters",
  fzlh: "Costume Illust",
  lhxz: "Illust Download",
  lh: "Illust",
  dt: "Zoom In",
  xt: "Zoom Out",
  gscg: "Story CG",
  hgddh: "Affection Anime",
  jndh: "Skill Anime",
  gjswttf: "No Ability",
  qhszdb: "Upgrade Detail",
  jnql: "Skill Potentials",
  jn: "Effect",
  sz: {
    qh: "Upgrade",
    xh: "SP Cost",
    lqsj: "CD",
    jnxg: "Effect",
    hh: "Turns"
  },
  daxx: "Info",
  jsyy: "Line",

  cqjy: "Pull Advice",
  qdfx: "Analysis",
  hjfx: "Meta",
  zrdp: "Team Composition",
  ckgd: "Show More",
  xhckxp: "Scroll to Fetish Review",
  xppc: "Fetish",
  jsmt: "Gallery",
  xct: "Official",
  jsda: "Character Profile",
  srht: "Birthday",
  ect: "Creators' Works",
  ssxfzzsxxpc: "No detailed review for 3&4 star costume",
  xggxfdwzbpcb: "You can check the review below",
  xggxfdzhpcb: "You can check the overall review below",
  ssxfzpc: "3&4 Star Costume Overall Review",
  sx: "Property",
  dqsz: "Stats",
  fctzjpb: "Recommended Option",
  qhfz: "Costume Switch",
  qhbdfz: "Bonding Switch",
  ky: "Engraving",
  jx: "Awakening",
  zcjsy: "Applied effect",
  fzgynlz: "Costume Permanent Stats",
  fzbdnlz: "Costume Bonding Stats",
  hydjsj: "Max Stats",

  tf: "Ability",
  tfqhxg: "Ability Upgrade",
  gjszwtf: "No Ability",
  jsxx: "Character Info",
  zjtj: "Most Recommended Team",
  xwtb: "Alternative",
  jnsm: "Skill Description",
  jnfw: "Skill Range",
  zzjzzo: "Loading.....",
  zlzskqlyrbzjj: "No data, please contact the administrator",
  gjsxydlhcngko: "Please login to continue~",
  dl: "Login",
  gjsxsmrzhcngko: "Only show after your ID Verificaition is completed~",
  smrz: "ID Verification",
  ndsmxxwwcnrbfnrwfll: "You cannot check the adult-only infomation",
  tt: "PvE",
  hjzwtjzr: "No recommended team",
  bhhxh: "SP Cost",
  chjqszd: "Starting SP",
  zjsysp: "SP Increase/Decrease",
  xhsp: "SP reduced",
  spbjbj: "SP unchanged",
  spsywf: "Not Enough SP",
  spszzdtzsyjnssxdds: "You need SP to use skills",
  mhhjssfhfsojnsxyhhzsphhfbfsp: "If 【SP restore】is used, SP will be restored next turn.",
  mhhjsgjhjtsxyhhzsphhf1sp: "If an ally uses 【Attack】or【Knockback】, restore 1 SP.",

  qsrxydzbmc: "Enter the name of gear",
  zyzb: "Exclusive",
  zzzb: "Crafted",
  mszb: "Fiend",
  jbnl: "Basic Stat",
  xxnl: "Options",
  zynl: "Exclusive Ability",
  cq: "Gacha",
  gl: "Rate",
  sj: "Random",
  x: "choose",
  dj: "Tiers",
  yb: "Ⅰ",
  gj: "Ⅱ",
  zgj: "Ⅲ",
  cs: "Ⅳ",
  scpzy: "Applied effect  ",
  xqcl: "Crafting Materials",
  jbnlms1: "Randomly unlock one stat from basic options (the rate of each option is the same)",
  xxnlms1:
    "When the gear is upgraded to levels 3, 6, and 9,randomly unlock one stat from the following options (the rate of each option is the same):HP, HP%,ATK, ATK%, CR, CDMG, DEF, MRES",
  xxnlms2:
    "When the gear is upgraded to levels 3, 6, and 9,randomly unlock one stat from the following options (the rate of each option is the same):HP, HP%,ATK, ATK%, CR, CDMG,MATK, MATK%, DEF, MRES",

  shengxing: "Upgrade",
  qh: "Upgrade",
  jt: "Knock back",
  gongji: "Attack",
  wfzd: "Death",

  专用: "Exclusive",
  制作: "Crafted",
  魔兽: "Fiend",

  武器: "Weapon",
  盔甲: "Armor",
  头盔: "Helmet",
  饰品: "Accessory",
  手套: "Gloves",

  生命力: "HP",
  攻击力: "ATK",
  魔法力: "Magic ATK",
  致命率: "Crit Rate",
  致命伤害: "Crit DMG",
  防御力: "DEF",
  魔法抵抗: "Magic Resist",
  火属性伤害: "Fire DMG",
  风属性伤害: "Wind DMG",
  水属性伤害: "Water DMG",
  光属性伤害: "Light DMG",
  暗属性伤害: "Darkness DMG",
  火属性抵抗: "Fire Resist",
  风属性抵抗: "Wind Resist",
  水属性抵抗: "Water Resist",
  属性抵抗: "Property Resist"
};
